import { render } from "./FinancialDocumentsView.vue?vue&type=template&id=b820fff0"
import script from "./FinancialDocumentsView.vue?vue&type=script&lang=js"
export * from "./FinancialDocumentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__